// extracted by mini-css-extract-plugin
export default {"svgObject":"InteractiveGraphicView_svgObject__OiGGi"};